﻿﻿﻿﻿﻿﻿﻿﻿﻿
import { Auth } from "./auth.js";
import { escapeHtml, showToast, countryToChinese } from "./utils.js";
// ===== 客户CRM管理模块 =====

let allCustomers = [];
let editingCustomerId = null;
let allFolders = [];
let currentFolderFilter = '';
let currentFiltered = [];
var _crmSelected = new Set();


// ===== 初始化 =====
function initCRM() {
    loadCustomers().then(function() { loadFolders(); });
}

// ===== API请求基础 =====
async function crmFetch(url, options = {}) {
    const token = Auth.getToken();
    const defaults = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }
    };
    const response = await fetch(url, { ...defaults, ...options });
    if (response.status === 401) {
        Auth.logout();
        return null;
    }
    return response;
}

// ===== 加载客户列表 =====
// ===== 列宽拖拽调整（事件委托） =====
var _crmDragCol = null, _crmDragStartX = 0, _crmDragStartW = 0;
function initCrmResize() {
  var header = document.getElementById('crm-resize-header');
  if (!header || header._crmInit) return;
  header._crmInit = true;
  console.log("[CRM Resize] init on header");
  header.addEventListener('mousedown', function(e) {
    var cell = e.target.closest ? e.target.closest('.crm-cell') : null;
    if (!cell) return;
    // Check if click is near right edge of cell (within 8px)
    var rect = cell.getBoundingClientRect();
    if (e.clientX < rect.right - 12 || e.clientX > rect.right + 2) return;
    var col = cell.getAttribute('data-col');
    if (!col || col === 'notes') return;
    e.preventDefault();
    _crmDragCol = col;
    _crmDragStartX = e.clientX;
    _crmDragStartW = cell.offsetWidth;
    cell.classList.add('dragging');
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
    console.log("[CRM Resize] start drag:", col, _crmDragStartW);
  });
  document.addEventListener('mousemove', function(e) {
    if (!_crmDragCol) return;
    var delta = e.clientX - _crmDragStartX;
    var newW = Math.max(20, _crmDragStartW + delta);
    document.documentElement.style.setProperty('--crm-col-' + _crmDragCol, newW + 'px');
    var saved = {};
    try { saved = JSON.parse(localStorage.getItem('crm_col_widths') || '{}'); } catch(ex) {}
    saved[_crmDragCol] = newW;
    localStorage.setItem('crm_col_widths', JSON.stringify(saved));
  });
  document.addEventListener('mouseup', function() {
    if (!_crmDragCol) return;
    var cells = header.querySelectorAll('.crm-cell');
    cells.forEach(function(c) { c.classList.remove('dragging'); });
    document.body.style.cursor = '';
    document.body.style.userSelect = '';
    _crmDragCol = null;
  });
}
function restoreCrmColWidths() {
  try {
    var saved = JSON.parse(localStorage.getItem('crm_col_widths') || '{}');
    Object.keys(saved).forEach(function(col) {
      document.documentElement.style.setProperty('--crm-col-' + col, saved[col] + 'px');
    });
  } catch(ex) {}
}

async function loadCustomers() {
    currentFolderFilter = '';
    await loadFolders();
    try {
        const resp = await crmFetch('/api/customers');
        if (!resp) return;
        const data = await resp.json();
        allCustomers = data.customers || [];
        renderCustomerTable(allCustomers);
        return allCustomers;
    } catch (err) {
        console.error('删除失败:', err);
    }
}

// ===== 渲染客户表格 =====
function renderCustomerTable(customers) {
    const grid = document.getElementById('customer-card-grid');
    if (!grid) return;
    if (!customers || customers.length === 0) {
        grid.innerHTML = '<div class="crm-empty"><i class="fa-solid fa-user-group"></i><p>暂无客户数据</p><button class="btn-radar btn-primary" onclick="showCustomerForm()">新增客户</button></div>';
        renderFolderList();
        restoreCrmColWidths();
        return;
    }
    grid.innerHTML = '<div class="crm-header" id="crm-resize-header" style="display:flex;align-items:center;gap:6px;padding:10px 12px;background:#f8fafc;border-bottom:1px solid #e2e8f0;font-weight:700;color:#64748b;font-size:0.78rem;">' +
        '<span class="crm-cell crm-cell-check" data-col="check" style="width:32px;flex-shrink:0;"><input type="checkbox" id="crm-select-all" onclick="toggleSelectAll()" style="cursor:pointer;"></span><span class="crm-cell crm-cell-star" data-col="star">星级</span>' +
        '<span class="crm-cell crm-cell-country" data-col="country">国家</span>' +
        '<span class="crm-cell crm-cell-contact" data-col="contact">联系人</span>' +
        '<span class="crm-cell crm-cell-consignee" data-col="consignee">收货人</span>' +
        '<span class="crm-cell crm-cell-phone" data-col="phone">电话</span>' +
        '<span class="crm-cell crm-cell-copywa" data-col="copywa"></span>' +
        '<span class="crm-cell crm-cell-whatsapp" data-col="whatsapp">WhatsApp</span>' +
        '<span class="crm-cell crm-cell-email" data-col="email">邮箱</span>' +
        '<span class="crm-cell crm-cell-address" data-col="address">地址</span>' +
        '<span class="crm-cell crm-cell-notes" data-col="notes">备注</span>' +
        '</div>' +
        customers.map(function(c) {
            var s = (c.star && c.star !== "undefined") ? c.star : "L0";
            var lockIcon = c.locked ? ' <i class="fa-solid fa-lock" style="color:#f59e0b;font-size:0.7rem;" title="已锁定"></i>' : '';
            var cells = [];
            cells.push('<span class="crm-cell crm-cell-check" style="width:32px;flex-shrink:0;"><input type="checkbox" ' + (_crmSelected.has(c.id) ? 'checked' : '') + ' onclick="event.stopPropagation();toggleSelectCustomer(\'' + c.id + '\')" style="cursor:pointer;"></span>');
            cells.push('<span class="crm-cell crm-cell-star"><span class="badge-star badge-' + s.toLowerCase() + '">' + s + '</span>' + lockIcon + '</span>');
            cells.push('<span class="crm-cell crm-cell-country" title="' + escapeHtml(c.country || '') + '">' + escapeHtml(c.country || '--') + '</span>');
            cells.push('<span class="crm-cell crm-cell-contact" title="' + escapeHtml(c.contact || '') + '">' + escapeHtml(c.contact || '--') + '</span>');
            cells.push('<span class="crm-cell crm-cell-consignee" title="' + escapeHtml(c.consignee || '') + '">' + escapeHtml(c.consignee || '--') + '</span>');
            cells.push('<span class="crm-cell crm-cell-phone">' + escapeHtml(c.phone || '--') + '</span>');
            cells.push('<span class="crm-cell crm-cell-copywa"><button class="crm-copywa-btn" onclick="event.stopPropagation();copyPhoneToWhatsappRow(\'' + c.id + '\')" title="复制电话为WhatsApp"><i class="fa-solid fa-arrow-right"></i></button></span>');
            cells.push('<span class="crm-cell crm-cell-whatsapp" id="wa-' + c.id + '">' + escapeHtml(c.whatsapp || '--') + '</span>');
            cells.push('<span class="crm-cell crm-cell-email" title="' + escapeHtml(c.email || '') + '">' + escapeHtml(c.email || '--') + '</span>');
            cells.push('<span class="crm-cell crm-cell-address" onclick="showAddressBubble(event, this, \'' + c.id + '\')" style="cursor:pointer">' + escapeHtml((c.address || '--').substring(0, 20)) + '</span>');
            cells.push('<span class="crm-cell crm-cell-notes" title="' + escapeHtml(String(c.notes || '')) + '">' + escapeHtml(String(c.notes || '--').substring(0, 20)) + '</span>');
            var rowStyle = 'display:flex;align-items:center;gap:6px;padding:7px 12px;border-bottom:1px solid #f1f5f9;cursor:pointer;transition:background 0.15s;font-size:0.8rem;color:#334155;' + (_crmSelected.has(c.id) ? 'background:#f0fdf4;' : '');
            return '<div class="crm-row" data-id="' + c.id + '" data-project="' + (c.isProject ? '1' : '0') + '" data-folder="' + (c.folderId || '') + '" data-locked="' + (c.locked ? '1' : '0') + '" oncontextmenu="showCrmContextMenu(event, this)" style="' + rowStyle + '">' +
                cells.join('') +
            '</div>';
        }).join('');
    renderFolderList();
    restoreCrmColWidths();
    initCrmResize();
}

// ===== 筛选客户 =====
function filterCustomers() {
    const search = document.getElementById('crm-search').value.toLowerCase();
    const starFilter = document.getElementById('crm-star-filter').value;
    const contactEl = document.getElementById('crm-contact-filter');
    const contactFilter = contactEl ? contactEl.value : '';
    
    let filtered = allCustomers;
    
    // 文件夹筛选
    if (currentFolderFilter === '__ungrouped__') {
        filtered = filtered.filter(function(c) { return !c.folderId; });
    } else if (currentFolderFilter) {
        filtered = filtered.filter(function(c) { return c.folderId === currentFolderFilter; });
    }
    
    if (starFilter) {
        filtered = filtered.filter(c => c.star === starFilter);
    }
    
    
    if (contactFilter === 'has_whatsapp') {
        filtered = filtered.filter(function(c) { return c.whatsapp && c.whatsapp.trim(); });
    } else if (contactFilter === 'has_email') {
        filtered = filtered.filter(function(c) { return c.email && c.email.includes('@'); });
    }
    if (search) {
        filtered = filtered.filter(c => 
            ((c.contact || '').toLowerCase().includes(search) ) ||
            (c.contact || '').toLowerCase().includes(search) ||
            (c.consignee || '').toLowerCase().includes(search) ||
            (c.email || '').toLowerCase().includes(search) ||
            (c.phone || '').includes(search) ||
            (c.country || '').toLowerCase().includes(search)
        );
    }
    
    currentFiltered = filtered;
    renderCustomerTable(filtered);
}

// ===== 显示客户表单 =====
function showCustomerForm(customer = null) {
    editingCustomerId = customer ? customer.id : null;
    document.getElementById('customer-form-title').innerHTML = 
        '<i class="fa-solid fa-user"></i> ' + (customer ? '编辑客户' : '新增客户');
    
    document.getElementById('cf-star').value = customer ? customer.star : 'L0';
    document.getElementById('cf-country').value = customer ? (customer.country || '') : '';
    
    document.getElementById('cf-contact').value = customer ? customer.contact : '';
    document.getElementById('cf-consignee').value = customer ? customer.consignee : '';
    document.getElementById('cf-phone').value = customer ? customer.phone : '';
    document.getElementById('cf-whatsapp').value = customer ? (customer.whatsapp || '') : '';
    document.getElementById('cf-email').value = customer ? customer.email : '';
    document.getElementById('cf-address').value = customer ? customer.address : '';
    document.getElementById('cf-notes').value = customer ? (customer.notes || '') : '';
    
    // 清空自定义字段容器
    const container = document.getElementById('custom-fields-container');
    container.innerHTML = '';
    
    // 如果是编辑，填充自定义字段
    if (customer && customer.customFields && customer.customFields.length > 0) {
        customer.customFields.forEach((field, idx) => {
                addCustomField(field.label, field.content);
            });
    }
    
    document.getElementById('customer-form-error').style.display = 'none';
    document.getElementById('customer-form-modal').style.display = 'flex';
}

// ===== 关闭客户表单 =====
function closeCustomerForm() {
    document.getElementById('customer-form-modal').style.display = 'none';
    editingCustomerId = null;
}

        // 默认两个自定义字段
function addCustomField(label = '', value = '') {
    const container = document.getElementById('custom-fields-container');
    const index = container.children.length + 1;
    
    const div = document.createElement('div');
    div.className = 'custom-field-row';
    div.dataset.index = index;
    div.innerHTML = `
        <div class="form-row">
            <div class="form-group" style="flex:0.3;">
                <label>自定义项内容${index}</label>
                <input type="text" class="cf-custom-label" value="${escapeHtml(label)}">
            </div>
            <div class="form-group">
                <label>自定义项内容${index}</label>
                <input type="text" class="cf-custom-value" value="${escapeHtml(value)}">
            </div>
            <div class="form-group" style="flex:0.1;align-items:flex-end;">
                <button class="btn-sm btn-delete" onclick="removeCustomField(this)" style="margin-top:20px;"><i class="fa-solid fa-times"></i></button>
            </div>
        </div>
    `;
    container.appendChild(div);
}

// ===== 删除自定义字段 =====
function removeCustomField(btn) {
    btn.closest('.custom-field-row').remove();
}

// ===== 保存客户 =====
async function submitCustomerForm() {
    const errorEl = document.getElementById('customer-form-error');
    
    const contact = document.getElementById('cf-contact').value.trim();
    if (!contact) {
        errorEl.textContent = '不能为空';
        errorEl.style.display = 'block';
        return;
    }
    
        // 解析自定义字段
    const customFields = [];
    document.querySelectorAll('.custom-field-row').forEach(row => {
        const label = row.querySelector('.cf-custom-label').value.trim();
        const content = row.querySelector('.cf-custom-value').value.trim();
        if (label || content) {
            customFields.push({ label, content });
        }
    });
    
    const customerData = {
        star: document.getElementById('cf-star').value,
        country: document.getElementById('cf-country').value.trim(),
        
        contact: document.getElementById('cf-contact').value.trim(),
        consignee: document.getElementById('cf-consignee').value.trim(),
        phone: document.getElementById('cf-phone').value.trim(),
        whatsapp: document.getElementById('cf-whatsapp').value.trim(),
        email: document.getElementById('cf-email').value.trim(),
        address: document.getElementById('cf-address').value.trim(),
        notes: document.getElementById('cf-notes').value.trim(),
        customFields: customFields
    };
    
    try {
        let resp;
        if (editingCustomerId) {
            resp = await crmFetch('/api/customers/' + editingCustomerId, {
                method: 'PUT',
                body: JSON.stringify(customerData)
            });
        } else {
            resp = await crmFetch('/api/customers', {
                method: 'POST',
                body: JSON.stringify(customerData)
            });
        }
        
        if (!resp) return;
        
        if (resp.ok) {
            closeCustomerForm();
            loadCustomers();
        } else {
            const err = await resp.json();
        errorEl.textContent = '不能为空';
            errorEl.style.display = 'block';
        }
    } catch (err) {
        errorEl.textContent = '不能为空';
        errorEl.style.display = 'block';
    }
}

// ===== 编辑客户 =====
async function editCustomer(id) {
    const customer = allCustomers.find(c => c.id === id);
    if (!customer) return;
    if (customer.locked) { alert('该客户已锁定，无法编辑。请先解锁。'); return; }
    showCustomerForm(customer);
}

// ===== 删除客户 =====
async function deleteCustomer(id) {
    var cust = allCustomers.find(function(c) { return c.id === id; });
    if (cust && cust.locked) { alert('该客户已锁定，无法删除。请先解锁。'); return; }
    if (!confirm('确定要删除该客户吗？')) return;
    
    try {
        const resp = await crmFetch('/api/customers/' + id, { method: 'DELETE' });
        if (resp && resp.ok) {
            loadCustomers();
        }
    } catch (err) {
        console.error('删除失败:', err);
    }
}

// ===== 导出客户CSV =====
// ===== 导出客户CSV =====
function exportCustomersCSV() {
    const exportData = currentFiltered.length > 0 ? currentFiltered : allCustomers;
    if (exportData.length === 0) {
        alert('没有客户数据可导出');
        return;
    }
    
    const maxCustom = Math.max(...exportData.map(function(c) { return (c.customFields || []).length; }), 2);
    const headers = ['星级', '国家', '联系人', '收货人', '电话', 'WhatsApp', '邮箱', '地址', '备注'];
    const dynamicHeaders = [];
    for (var i = 1; i <= maxCustom; i++) {
        dynamicHeaders.push('自定义项' + i + '标签', '自定义项' + i + '内容');
    }
    
    const rows = exportData.map(function(c) {
        const base = [c.star, c.country || '', c.contact || '', c.consignee || '', c.phone || '', c.whatsapp || '', c.email || '', c.address || '', c.notes || ''];
        const custom = [];
        for (var i = 0; i < maxCustom; i++) {
            if (c.customFields && c.customFields[i]) {
                custom.push(c.customFields[i].label || '', c.customFields[i].content || '');
            } else {
                custom.push('', '');
            }
        }
        return base.concat(custom);
    });
    
    const allHeaders = headers.concat(dynamicHeaders);
    const csvContent = [allHeaders.join(','), rows.map(function(r) { return r.map(function(v) { return '"' + String(v).replace(/"/g, '""') + '"'; }).join(','); }).join('\n')].join('\n');
    
    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = '客户导出_' + new Date().toISOString().slice(0, 10) + '.csv';
    a.click();
    URL.revokeObjectURL(url);
}
// ===== 导入客户 =====
function downloadCustomerTemplate() {
    const headers = ['星级', '国家', '联系人', '收货人', '电话', 'WhatsApp', '邮箱', '地址', '备注'];
    const exampleRow = ['L0', '加拿大', '杨思敏', '杨思敏', '+86 13560723375', '+86 13560723375', 'samson@example.com', '123 Business Road, Vancouver, Canada', '重要客户-示例'];
    
    const csvContent = [headers.join(','), exampleRow.map(v => '"' + String(v).replace(/"/g, '""') + '"').join(',')].join('\n');
    
    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = '客户导入模板.csv';
    a.click();
    URL.revokeObjectURL(url);
}

// ===== 导入客户 =====
async function importCustomers(input) {
    var file = input.files[0];
    if (!file) return;
    
    async function doImport(customers) {
        if (customers.length === 0) {
        alert('未识别到有效的客户数据');
            return;
        }
        var resp = await crmFetch('/api/customers/import', {
            method: 'POST',
            body: JSON.stringify({ customers: customers })
        });
        if (resp && resp.ok) {
            var result = await resp.json();
        alert('导入成功: ' + (result.imported || customers.length) + ' 条客户记录');
            loadCustomers();
        } else {
            var errText = resp ? await resp.text() : '网络错误';
        alert('导入失败: ' + errText);
        }
    }
    
    function tryDecode(buffer, encoding) {
        var decoder = new TextDecoder(encoding);
        return decoder.decode(buffer);
    }
    
    function detectAndParseCSV(buffer) {
        var text = tryDecode(buffer, "utf-8");
        var customers = parseCSV(text);
        if (customers.length > 0) return customers;
        text = tryDecode(buffer, "gbk");
        return parseCSV(text);
    }
    
    if (file.name.endsWith('.xlsx')) {
        var reader = new FileReader();
        reader.onload = async function(e) {
            try {
                var data = new Uint8Array(e.target.result);
                var wb = XLSX.read(data, { type: 'array' });
                var sheetName = wb.SheetNames[0];
                var rows = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], { header: 1 });
                var customers = rowsToCustomers(rows);
                await doImport(customers);
            } catch (err) {
        alert('导入失败: ' + err.message);
            }
        };
        reader.readAsArrayBuffer(file);
    } else {
        var reader = new FileReader();
        reader.onload = async function(e) {
            try {
                var customers = [];
                if (file.name.endsWith('.json')) {
                    var data = JSON.parse(e.target.result);
                    customers = Array.isArray(data) ? data : data.customers || [];
                } else if (file.name.endsWith('.csv')) {
                    var buffer = new Uint8Array(e.target.result);
                    customers = detectAndParseCSV(buffer);
                }
                await doImport(customers);
            } catch (err) {
        alert('导入失败: ' + err.message);
            }
        };
        reader.readAsArrayBuffer(file);
    }
    input.value = '';
}


// ===== 导入客户 =====
function rowsToCustomers(rows) {
    if (!rows || rows.length < 2) return [];
    var headers = rows[0].map(function(h) { return String(h || "").replace(/^\uFEFF/, "").trim(); });
    var customers = [];
    for (var i = 1; i < rows.length; i++) {
        var values = rows[i];
        if (!values || values.length < 2) continue;
        var row = {};
        headers.forEach(function(h, idx) { row[h] = (String(values[idx] || "")).trim(); });
        var customer = {
            star: row["星级"] || row["star"] || "L0",
            country: countryToChinese(row["国家"] || row["country"]),
            contact: row["联系人"] || row["contact"] || "",
            consignee: row["收货人"] || row["consignee"] || "",
            phone: row["电话"] || row["phone"] || "",
            whatsapp: row["WhatsApp"] || row["whatsapp"] || "",
            email: row["邮箱"] || row["email"] || "",
            address: row["地址"] || row["address"] || "",
            _notes: row["备注"] || row["notes"] || "",
            customFields: []
        };
        for (var j = 1; j <= 10; j++) {
            var label = row["自定义项" + j + "标签"] || row["custom" + j + "_label"] || "";
            var content = row["自定义项" + j + "内容"] || row["custom" + j + "_content"] || "";
            if (label || content) customer.customFields.push({ label: label, content: content });
        }
        if (customer.contact) customers.push(customer);
    }
    return customers;
}

function parseCSV(text) {
    var rawLines = text.split(/\r?\n/);
    var lines = [];
    var current = "";
    for (var i = 0; i < rawLines.length; i++) {
        if (current) {
            current += "\n" + rawLines[i];
        } else {
            current = rawLines[i];
        }
        var quotes = (current.match(/"/g) || []).length;
        if (quotes % 2 === 0) {
            if (current.trim()) lines.push(current);
            current = "";
        }
    }
    if (current.trim()) lines.push(current);
    if (lines.length < 2) return [];
    var rows = lines.map(function(l) { return parseCSVLine(l); });
    return rowsToCustomers(rows);
}
function parseCSVLine(line) {
    const result = [];
    let current = '';
    let inQuotes = false;
    
    for (let i = 0; i < line.length; i++) {
        const char = line[i];
        if (char === '"') {
            if (inQuotes && line[i + 1] === '"') {
                current += '"';
                i++;
            } else {
                inQuotes = !inQuotes;
            }
        } else if (char === ',' && !inQuotes) {
            result.push(current);
            current = '';
        } else {
            current += char;
        }
    }
    result.push(current);
    return result;
}


// ===== 文件夹管理 =====
async function loadFolders() {
    try {
        var resp = await crmFetch('/api/customer-folders');
        if (!resp) return;
        var data = await resp.json();
        allFolders = data.folders || [];
        renderFolderList();
    } catch (err) {
        console.error('加载文件夹失败:', err);
    }
}

function renderFolderList() {
    var list = document.getElementById('crm-client-list');
    if (!list) return;
    var counts = {};
    var ungrouped = 0;
    allCustomers.forEach(function(c) {
        if (c.folderId) { counts[c.folderId] = (counts[c.folderId] || 0) + 1; }
        else { ungrouped++; }
    });
    var html = '';
    html += '<div class="folder-group" style="margin-bottom:2px;">';
    html += '<div class="folder-header' + (currentFolderFilter === '' ? ' active' : '') + '" onclick="selectFolder(\'\')" style="padding:10px 15px;background:#f1f5f9;border-bottom:1px solid #e2e8f0;cursor:pointer;display:flex;align-items:center;font-size:12px;font-weight:700;color:#475569;">';
    html += '<i class="fa-solid fa-users" style="margin-right:8px;color:#3b82f6;"></i><span style="flex:1">全部客户</span>';
    html += '<span style="background:#cbd5e1;padding:1px 6px;border-radius:10px;font-size:10px;">' + allCustomers.length + '</span>';
    html += '</div></div>';
    html += '<div class="folder-group" style="margin-bottom:2px;">';
    html += '<div class="folder-header' + (currentFolderFilter === '__ungrouped__' ? ' active' : '') + '" onclick="selectFolder(\'__ungrouped__\')" style="padding:10px 15px;background:#f1f5f9;border-bottom:1px solid #e2e8f0;cursor:pointer;display:flex;align-items:center;font-size:12px;font-weight:700;color:#475569;">';
    html += '<i class="fa-solid fa-folder-open" style="margin-right:8px;color:#94a3b8;"></i><span style="flex:1">未分类</span>';
    html += '<span style="background:#cbd5e1;padding:1px 6px;border-radius:10px;font-size:10px;">' + ungrouped + '</span>';
    html += '</div></div>';
    html += '<div style="border-bottom:2px solid #cbd5e1;margin:8px 15px;"></div>';
    allFolders.forEach(function(f) {
        var safeName = f.name.replace(/'/g, "\\'");
        var count = counts[f.id] || 0;
        html += '<div class="folder-group" style="margin-bottom:2px;">';
        html += '<div class="folder-header' + (currentFolderFilter === f.id ? ' active' : '') + '" onclick="selectFolder(\'' + f.id + '\')" style="padding:10px 15px;background:#f1f5f9;border-bottom:1px solid #e2e8f0;cursor:pointer;display:flex;align-items:center;font-size:12px;font-weight:700;color:#475569;">';
        html += '<i class="fa-solid fa-folder" style="margin-right:8px;color:#fbbf24;"></i><span style="flex:1">' + escapeHtml(f.name) + '</span>';
        html += '<span style="background:#cbd5e1;padding:1px 6px;border-radius:10px;font-size:10px;margin-right:8px;">' + count + '</span>';
        html += '<div style="display:inline-flex;gap:5px;align-items:center;">';
        html += '<i class="fa-solid fa-arrow-up" onclick="event.stopPropagation();moveCrmFolder(-1,\'' + f.id + '\')" style="font-size:10px;color:#64748b;cursor:pointer;" title="上移"></i>';
        html += '<i class="fa-solid fa-arrow-down" onclick="event.stopPropagation();moveCrmFolder(1,\'' + f.id + '\')" style="font-size:10px;color:#64748b;cursor:pointer;" title="下移"></i>';
        html += '<i class="fa-solid fa-pen" onclick="event.stopPropagation();renameFolderPrompt(\'' + f.id + '\',\'' + safeName + '\')" style="font-size:10px;color:#64748b;cursor:pointer;" title="重命名"></i>';
        html += '<i class="fa-solid fa-trash-can" onclick="event.stopPropagation();deleteFolderPrompt(\'' + f.id + '\')" style="font-size:10px;color:#ef4444;opacity:0.6;cursor:pointer;" title="删除"></i>';
        html += '</div></div></div>';
    });
    list.innerHTML = html;
}

function selectFolder(folderId) {
    currentFolderFilter = folderId;
    filterCustomers();
}


async function addCustomerFolder() {
    var name = prompt('请输入文件夹名称:');
    if (!name || !name.trim()) return;
    try {
        var resp = await crmFetch('/api/customer-folders', {
            method: 'POST',
            body: JSON.stringify({ name: name.trim() })
        });
        if (resp && resp.ok) { await loadFolders(); }
    } catch (err) { console.error('新建文件夹失败:', err); }
}

async function renameFolderPrompt(id, oldName) {
    var name = prompt('重命名文件夹:', oldName);
    if (!name || !name.trim()) return;
    try {
        var resp = await crmFetch('/api/customer-folders/' + id, {
            method: 'PUT',
            body: JSON.stringify({ name: name.trim() })
        });
        if (resp && resp.ok) { await loadFolders(); }
    } catch (err) { console.error('重命名失败:', err); }
}

async function deleteFolderPrompt(id) {
    if (!confirm('确定要删除此文件夹吗？文件夹内的客户将移入"未分组"。')) return;
    try {
        var resp = await crmFetch('/api/customer-folders/' + id, { method: 'DELETE' });
        if (resp && resp.ok) {
            allCustomers.forEach(function(c) { if (c.folderId === id) delete c.folderId; });
            await loadCustomers();
            await loadFolders();
        }
    } catch (err) { console.error('删除文件夹失败:', err); }
}

async function moveCustomerToFolder(customerId, folderId) {
    try {
        var resp = await crmFetch('/api/customers/' + customerId + '/folder', {
            method: 'PUT',
            body: JSON.stringify({ folderId: folderId || null })
        });
        if (resp && resp.ok) {
            var customer = allCustomers.find(function(c) { return c.id === customerId; });
            if (customer) {
                if (folderId) { customer.folderId = folderId; }
                else { delete customer.folderId; }
            }
            renderFolderList();
        }
    } catch (err) { console.error('移动客户失败:', err); }
}

// ===== 导入客户 =====
// ===== 导入客户 =====
async function copyPhoneToWhatsapp(id, btn) {
    const customer = allCustomers.find(c => c.id === id);
    if (!customer || !customer.phone) return;
    customer.whatsapp = customer.phone;
    // 即时更新DOM
    const row = btn.closest('tr');
    if (row) {
        const cells = row.querySelectorAll('td');
        if (cells.length >= 7) { cells[6].textContent = customer.phone; }
    }
    // 后台保存到服务器
    crmFetch('/api/customers/' + id, {
        method: 'PUT',
        body: JSON.stringify(customer)
    }).catch(err => console.error('同步WhatsApp失败:', err));
}



function truncate(str, len) {
    if (!str) return '';
    return str.length > len ? str.substring(0, len) + '...' : str;
}

async function moveCrmFolder(direction, id) {
    const index = allFolders.findIndex(f => f.id === id);
    if (index === -1) return;

    const newIndex = index + direction;
    if (newIndex < 0 || newIndex >= allFolders.length) return;

    // 交换位置
    const temp = allFolders[index];
    allFolders[index] = allFolders[newIndex];
    allFolders[newIndex] = temp;

    // 重新渲染本地
    renderFolderList();
    restoreCrmColWidths();
    initCrmResize();

    // 同步到后端
    try {
        const token = Auth.getToken();
        const folderIds = allFolders.map(f => f.id);
        await fetch('/api/customer-folders/reorder', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
            body: JSON.stringify({ folderIds })
        });
        console.log('[CRM] 顺序同步完成');
    } catch (e) {
        console.error('排序同步失败:', e);
    }
}

// ===== 地址气泡 =====
function showAddressBubble(e, el, customerId) {
    e.stopPropagation();
    document.querySelectorAll('.address-bubble').forEach(function(b){b.remove();});
    var customer = allCustomers.find(function(c){return c.id === customerId;});
    if (!customer || !customer.address) return;
    var rect = el.getBoundingClientRect();
    var bubble = document.createElement('div');
    bubble.className = 'address-bubble';
    bubble.innerHTML = '<span class="addr-text">' + escapeHtml(customer.address) + '</span>' +
        '<button class="addr-copy-btn" onclick="copyAddressBubble(this)" title="复制地址"><i class="fa-solid fa-copy"></i> 复制</button>';
    bubble.style.left = rect.left + 'px';
    bubble.style.top = (rect.bottom + 4) + 'px';
    document.body.appendChild(bubble);
    setTimeout(function() {
        document.addEventListener('click', function dismiss(ev) {
            if (!bubble.contains(ev.target) && ev.target !== el) {
                bubble.remove();
                document.removeEventListener('click', dismiss);
            }
        });
    }, 10);
}
function copyAddressBubble(btn) {
    var text = btn.parentElement.querySelector('.addr-text').textContent;
    navigator.clipboard.writeText(text).then(function() {
        btn.innerHTML = '<i class="fa-solid fa-check"></i> 已复制';
        btn.classList.add('addr-copied');
        setTimeout(function() {
            btn.innerHTML = '<i class="fa-solid fa-copy"></i> 复制';
            btn.classList.remove('addr-copied');
        }, 1500);
    }).catch(function() {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        btn.innerHTML = '<i class="fa-solid fa-check"></i> 已复制';
        btn.classList.add('addr-copied');
        setTimeout(function() {
            btn.innerHTML = '<i class="fa-solid fa-copy"></i> 复制';
            btn.classList.remove('addr-copied');
        }, 1500);
    });
}
async function toggleProject(id, isProject) {
    try {
        const resp = await crmFetch('/api/customers/' + id + '/project', {
            method: 'PUT',
            body: JSON.stringify({ isProject })
        });
        if (resp && resp.ok) {
            console.log('[CRM] 专案状态更新成功');
            await loadCustomers(); // 刷新表格
            // 提示用户
            const msg = isProject ? '已加入专案' : '已退出专案';
            showToast('专案状态', msg, 'success');
        }
    } catch (err) {
        console.error('更新专案状态失败:', err);
    }
}


// ===== 复制电话为WhatsApp（flex行布局）=====
function copyPhoneToWhatsappRow(id) {
    var customer = allCustomers.find(function(c) { return c.id === id; });
    if (!customer || !customer.phone) return;
    customer.whatsapp = customer.phone;
    var el = document.getElementById('wa-' + id);
    if (el) el.textContent = customer.phone;
    crmFetch('/api/customers/' + id, {
        method: 'PUT',
        body: JSON.stringify(customer)
    }).catch(function(err) { console.error('同步WhatsApp失败:', err); });
}

// ===== 右键菜单 =====
function showCrmContextMenu(e, row) {
    e.preventDefault();
    e.stopPropagation();
    removeCrmContextMenu();
    var customerId = row.getAttribute('data-id');
    var isProject = row.getAttribute('data-project') === '1';
    var isLocked = row.getAttribute('data-locked') === '1';
    var menu = document.createElement('div');
    menu.className = 'crm-context-menu';
    menu.style.left = e.clientX + 'px';
    menu.style.top = e.clientY + 'px';
    menu.innerHTML =
        '<div class="crm-menu-item" onclick="toggleProject(\'' + customerId + '\',' + (!isProject) + ');removeCrmContextMenu();">' +
            '<i class="fa-solid ' + (isProject ? 'fa-star' : 'fa-star-half-stroke') + '"></i> ' + (isProject ? '取消专案' : '加入专案') +
        '</div>' +
        '<div class="crm-menu-item" onclick="editCustomer(\'' + customerId + '\');removeCrmContextMenu();">' +
            '<i class="fa-solid fa-pen-to-square"></i> 编辑' +
        '</div>' +
        '<div class="crm-menu-item" onclick="toggleLock(\'' + customerId + '\');removeCrmContextMenu();">' +
            '<i class="fa-solid ' + (isLocked ? 'fa-unlock' : 'fa-lock') + '"></i> ' + (isLocked ? '解锁' : '锁定') +
        '</div>' +
        '<div class="crm-menu-item crm-menu-item-danger" onclick="deleteCustomer(\'' + customerId + '\');removeCrmContextMenu();">' +
            '<i class="fa-solid fa-trash"></i> 删除' +
        '</div>' +
        '<div class="crm-menu-item crm-menu-move" onmouseenter="showCrmMoveSubmenu(this,\'' + customerId + '\')" onmouseleave="hideCrmMoveSubmenu(this)">' +
            '<i class="fa-solid fa-folder-open"></i> 移动 <span class="crm-submenu-arrow">\u25B8</span>' +
        '</div>';
    document.body.appendChild(menu);
    setTimeout(function() {
        document.addEventListener('click', removeCrmContextMenu, {once: true});
    }, 0);
}
function removeCrmContextMenu() {
    var m = document.querySelector('.crm-context-menu');
    if (m) m.remove();
}
function showCrmMoveSubmenu(el, customerId) {
    hideCrmMoveSubmenu(el);
    var sub = document.createElement('div');
    sub.className = 'crm-submenu';
    sub.style.display = 'block';
    var folderItems = '';
    folderItems = '<div class="crm-submenu-item crm-submenu-moveout" onclick="moveCustomerToFolder(\'' + customerId + '\',null);removeCrmContextMenu();">📂 移出至未分类</div>';
    allFolders.forEach(function(f) {
        folderItems += '<div class="crm-submenu-item" onclick="moveCustomerToFolder(\'' + customerId + '\',\'' + f.id + '\');removeCrmContextMenu();">' +
            escapeHtml(f.name) + '</div>';
    });
    if (!allFolders.length) { folderItems += '<div class="crm-submenu-item crm-submenu-empty">暂无文件夹</div>'; }
    sub.innerHTML = folderItems;
    el.appendChild(sub);
}
function hideCrmMoveSubmenu(el) {
    var s = el.querySelector('.crm-submenu');
    if (s) s.remove();
}


// ===== DOMContentLoaded =====
document.addEventListener('DOMContentLoaded', function() {
    initCRM();
});



// ===== 导出邮箱TXT =====
function exportEmailsTxt() {
    const data = currentFiltered.length > 0 ? currentFiltered : allCustomers;
    const emails = [];
    data.forEach(function(c) {
        if (c.email && c.email.includes('@')) {
            emails.push(c.email.trim());
        }
    });
    if (emails.length === 0) {
        alert('没有可导出的邮箱');
        return;
    }
    const BOM = '\uFEFF';
    const content = BOM + emails.join(', ');
    const blob = new Blob([content], { type: 'text/plain;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = '客户邮箱_' + new Date().toISOString().slice(0, 10) + '.txt';
    a.click();
    URL.revokeObjectURL(url);
}


// window bridges for template onclick handlers

// ===== 锁定/解锁客户 =====
async function toggleLock(id) {
    var cust = allCustomers.find(function(c) { return c.id === id; });
    if (!cust) return;
    var newLocked = !cust.locked;
    try {
        var resp = await crmFetch('/api/customers/' + id + '/lock', {
            method: 'PUT',
            body: JSON.stringify({ locked: newLocked })
        });
        if (resp && resp.ok) {
            var data = await resp.json();
            cust.locked = data.customer.locked;
            renderCustomerTable(currentFiltered.length > 0 ? currentFiltered : allCustomers);
        }
    } catch (err) {
        console.error('锁定操作失败:', err);
    }
}


function toggleSelectAll() {
    var cb = document.getElementById("crm-select-all");
    var list = currentFiltered.length > 0 ? currentFiltered : allCustomers;
    if (cb.checked) {
        list.forEach(function(c) { _crmSelected.add(c.id); });
    } else {
        _crmSelected.clear();
    }
    document.querySelectorAll(".crm-row").forEach(function(row) {
        var id = row.getAttribute("data-id");
        var chk = row.querySelector('input[type="checkbox"]');
        var selected = _crmSelected.has(id);
        if (chk) chk.checked = selected;
        row.style.background = selected ? "#f0fdf4" : "";
    });
    updateBulkBar();
}

function toggleSelectCustomer(id) {
    if (_crmSelected.has(id)) {
        _crmSelected.delete(id);
    } else {
        _crmSelected.add(id);
    }
    updateBulkBar();
    // Update row background only
    var row = document.querySelector('.crm-row[data-id="' + id + '"]');
    if (row) row.style.background = _crmSelected.has(id) ? "#f0fdf4" : "";
    var cb = document.getElementById("crm-select-all");
    if (cb) {
        var list = currentFiltered.length > 0 ? currentFiltered : allCustomers;
        cb.checked = _crmSelected.size === list.length;
        cb.indeterminate = _crmSelected.size > 0 && _crmSelected.size < list.length;
    }
}

function clearCrmSelection() {
    _crmSelected.clear();
    document.querySelectorAll(".crm-row").forEach(function(row) {
        var chk = row.querySelector('input[type="checkbox"]');
        if (chk) chk.checked = false;
        row.style.background = "";
    });
    updateBulkBar();
}

function updateBulkBar() {
    var bar = document.getElementById("crm-bulk-bar");
    var countEl = document.getElementById("crm-bulk-count");
    if (!bar || !countEl) return;
    if (_crmSelected.size > 0) {
        bar.style.display = "flex";
        countEl.textContent = "已选 " + _crmSelected.size + " 项";
    } else {
        bar.style.display = "none";
    }
    var cb = document.getElementById("crm-select-all");
    if (cb) {
        var list = currentFiltered.length > 0 ? currentFiltered : allCustomers;
        cb.checked = _crmSelected.size === list.length && list.length > 0;
        cb.indeterminate = _crmSelected.size > 0 && _crmSelected.size < list.length;
    }
}

async function bulkDeleteCustomers() {
    if (_crmSelected.size === 0) return;
    if (!confirm("确定要删除 " + _crmSelected.size + " 个客户吗？此操作不可撤销。")) return;
    try {
        var resp = await crmFetch("/api/customers/bulk-delete", {
            method: "POST",
            body: JSON.stringify({ ids: Array.from(_crmSelected) })
        });
        if (resp && resp.ok) {
            var result = await resp.json();
            alert("已删除 " + result.deleted + " 个客户，跳过 " + (result.skipped || 0) + " 个");
            _crmSelected.clear();
            updateBulkBar();
            loadCustomers();
        } else {
            var err = resp ? await resp.text() : "请求失败";
            alert("删除失败: " + err);
        }
    } catch (err) {
        alert("删除失败: " + err.message);
    }
}

async function bulkLockCustomers() {
    if (_crmSelected.size === 0) return;
    var ids = Array.from(_crmSelected);
    // Determine if mostly locked or unlocked
    var list = currentFiltered.length > 0 ? currentFiltered : allCustomers;
    var lockedCount = 0;
    ids.forEach(function(id) {
        var c = list.find(function(x) { return x.id === id; });
        if (c && c.locked) lockedCount++;
    });
    var shouldLock = lockedCount < ids.length / 2;
    var action = shouldLock ? "锁定" : "解锁";
    if (!confirm("确定要" + action + " " + ids.length + " 个客户吗？")) return;
    try {
        var resp = await crmFetch("/api/customers/bulk-lock", {
            method: "POST",
            body: JSON.stringify({ ids: ids, locked: shouldLock })
        });
        if (resp && resp.ok) {
            var result = await resp.json();
            alert("已" + action + " " + result.updated + " 个客户");
            _crmSelected.clear();
            updateBulkBar();
            loadCustomers();
        }
    } catch (err) {
        alert("操作失败: " + err.message);
    }
}

async function bulkAddToProject() {
    if (_crmSelected.size === 0) return;
    var ids = Array.from(_crmSelected);
    if (!confirm("确定将 " + ids.length + " 个客户加入专案吗？")) return;
    try {
        var resp = await crmFetch("/api/customers/bulk-project", {
            method: "POST",
            body: JSON.stringify({ ids: ids })
        });
        if (resp && resp.ok) {
            var result = await resp.json();
            alert("已将 " + result.updated + " 个客户加入专案");
            _crmSelected.clear();
            updateBulkBar();
            loadCustomers();
        }
    } catch (err) {
        alert("操作失败: " + err.message);
    }
}

async function bulkMoveCustomers() {
    if (_crmSelected.size === 0) return;
    // Remove any existing menu
    var old = document.getElementById('crm-bulk-move-menu');
    if (old) old.remove();
    // Build folder menu
    var menu = document.createElement('div');
    menu.id = 'crm-bulk-move-menu';
    menu.style.cssText = 'position:absolute;z-index:9999;background:#fff;border:1px solid #e2e8f0;border-radius:6px;box-shadow:0 4px 12px rgba(0,0,0,0.15);min-width:160px;max-height:300px;overflow-y:auto;padding:4px 0;';
    var items = '<div style="padding:8px 14px;cursor:pointer;color:#64748b;font-size:0.8rem;" onclick="doBulkMove(null);document.getElementById(\'crm-bulk-move-menu\').remove();">📂 移至未分类</div>';
    allFolders.forEach(function(f) {
        items += '<div style="padding:8px 14px;cursor:pointer;font-size:0.82rem;" onmouseenter="this.style.background=\'#f1f5f9\'" onmouseleave="this.style.background=\'\'" onclick="doBulkMove(\'' + f.id + '\');document.getElementById(\'crm-bulk-move-menu\').remove();">' + escapeHtml(f.name) + '</div>';
    });
    if (!allFolders.length) items += '<div style="padding:8px 14px;color:#94a3b8;font-size:0.8rem;">暂无文件夹</div>';
    menu.innerHTML = items;
    document.body.appendChild(menu);
    // Position near bulk bar
    var bar = document.getElementById('crm-bulk-bar');
    if (bar) {
        var rect = bar.getBoundingClientRect();
        menu.style.top = (rect.bottom + 4) + 'px';
        menu.style.left = rect.left + 'px';
    }
    // Click outside to close
    setTimeout(function() {
        document.addEventListener('click', function closeBulkMove(e) {
            var m = document.getElementById('crm-bulk-move-menu');
            if (m && !m.contains(e.target)) { m.remove(); document.removeEventListener('click', closeBulkMove); }
        });
    }, 50);
}

async function doBulkMove(folderId) {
    var ids = Array.from(_crmSelected);
    try {
        var resp = await crmFetch('/api/customers/bulk-move', {
            method: 'POST',
            body: JSON.stringify({ ids: ids, folderId: folderId || null })
        });
        if (resp && resp.ok) {
            var result = await resp.json();
            alert('已移动 ' + result.moved + ' 个客户');
            _crmSelected.clear();
            updateBulkBar();
            loadCustomers();
        }
    } catch (err) {
        alert('操作失败: ' + err.message);
    }
}
window.selectFolder = selectFolder;
window.addCustomerFolder = addCustomerFolder;
window.exportCustomersCSV = exportCustomersCSV;
window.downloadCustomerTemplate = downloadCustomerTemplate;
window.importCustomers = importCustomers;
window.showCustomerForm = showCustomerForm;
window.closeCustomerForm = closeCustomerForm;
window.addCustomField = addCustomField;
window.toggleProject = toggleProject;
window.saveCustomer = submitCustomerForm;

window.deleteCustomer = deleteCustomer;
window.editCustomer = editCustomer;
window.removeCustomField = removeCustomField;

window.copyPhoneToWhatsapp = copyPhoneToWhatsapp;
window.moveCrmFolder = moveCrmFolder;
window.renameFolderPrompt = renameFolderPrompt;

window.deleteFolderPrompt = deleteFolderPrompt;
window.moveCustomerToFolder = moveCustomerToFolder;
window.filterCustomers = filterCustomers;
window.showCrmContextMenu = showCrmContextMenu;
window.removeCrmContextMenu = removeCrmContextMenu;
window.showCrmMoveSubmenu = showCrmMoveSubmenu;
window.hideCrmMoveSubmenu = hideCrmMoveSubmenu;
window.showAddressBubble = showAddressBubble;
window.copyAddressBubble = copyAddressBubble;
window.copyPhoneToWhatsappRow = copyPhoneToWhatsappRow;
window.exportEmailsTxt = exportEmailsTxt;

async function dedupCustomers() {
    var fieldEl = document.getElementById("crm-dedup-field");
    var field = fieldEl ? fieldEl.value : "";
    if (!field) { alert("请先选择去重字段"); return; }
    try {
        var resp = await crmFetch('/api/customers/dedup', {
            method: 'POST',
            body: JSON.stringify({ field: field })
        });
        if (!resp || !resp.ok) {
            var err = resp ? await resp.text() : '请求失败';
            alert('去重失败: ' + err);
            return;
        }
        var result = await resp.json();
        if (result.groups === 0) {
            alert('未发现重复客户');
            return;
        }
        var msg = '发现 ' + result.groups + ' 组重复，将删除 ' + result.deleted + ' 条，保留最早创建的。确认？';
        if (confirm(msg)) {
            var execResp = await crmFetch('/api/customers/dedup', {
                method: 'POST',
                body: JSON.stringify({ field: field, execute: true })
            });
            if (execResp && execResp.ok) {
                var execResult = await execResp.json();
                alert('已删除 ' + execResult.deleted + ' 条重复客户');
                loadCustomers();
            }
        }
    } catch (err) {
        alert('去重失败: ' + err.message);
    }
}
window.dedupCustomers = dedupCustomers;
window.toggleLock = toggleLock;
window.toggleSelectAll = toggleSelectAll;
window.toggleSelectCustomer = toggleSelectCustomer;
window.clearCrmSelection = clearCrmSelection;
window.bulkDeleteCustomers = bulkDeleteCustomers;
window.bulkLockCustomers = bulkLockCustomers;
window.bulkAddToProject = bulkAddToProject;
window.bulkMoveCustomers = bulkMoveCustomers;
window.doBulkMove = doBulkMove;
window.updateBulkBar = updateBulkBar;

export { initCRM };
